export default __webpack_public_path__ + "static/media/1.5168e965.jpg";